import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/home.vue'
import Services from './views/services.vue'
import Company from './views/company.vue'
import Recruit from './views/recruit.vue'
import Contact from './views/contact.vue'
import ContactAfter from './views/contact-after.vue'
import Privacy from './views/privacy.vue'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			name: 'home',
			component: Home
		},
		{
			path: '/services',
			name: 'servicesPage',
			component: Services
		},
		{
			path: '/company',
			name: 'companyPage',
			component: Company
		},
		{
			path: '/recruit',
			name: 'recruitPage',
			component: Recruit
		},
		{
			path: '/contact',
			name: 'contactPage',
			component: Contact
		},
		{
			path: '/contact-after',
			name: 'contactAfterPage',
			component: ContactAfter
		},
		{
			path: '/privacy',
			name: 'privacyPage',
			component: Privacy
		}
	]
})
